/* AFERIY recommended products: fixed-height vertical scroller + body-level variant popover.
 * The popover is independent of card layout and does not affect sticky cart/gallery.
 */
(()=>{
  'use strict';
  const active=new WeakSet();
  const rect=el=>el?.getBoundingClientRect();
  let current=null,popover=null;

  function closeMenu({focus=false}={}){
    if(!current)return;
    const trigger=current.trigger;
    trigger?.setAttribute('aria-expanded','false');
    popover?.setAttribute('data-open','false');
    if(popover)popover.replaceChildren();
    current=null;
    if(focus&&trigger?.isConnected)trigger.focus({preventScroll:true});
  }
  function ensurePopover(){
    if(popover)return popover;
    popover=document.createElement('div');
    popover.className='af-rec-variant-popover';
    popover.id='af-rec-variant-popover';
    popover.setAttribute('role','listbox');
    popover.setAttribute('aria-label','Opciones disponibles');
    popover.setAttribute('data-open','false');
    document.body.appendChild(popover);
    return popover;
  }
  function positionMenu(){
    if(!current||!popover)return;
    const {trigger,scroller}=current;
    if(!trigger.isConnected){closeMenu();return;}
    const r=rect(trigger),s=rect(scroller);
    if(!r||!s||r.bottom<s.top+2||r.top>s.bottom-2){closeMenu();return;}
    const vw=document.documentElement.clientWidth||window.innerWidth;
    const vh=window.innerHeight;
    const width=Math.min(Math.max(r.width,185),310,vw-16);
    const left=Math.min(Math.max(8,r.left),vw-width-8);
    const below=vh-r.bottom-9,above=r.top-9;
    const desired=Math.min(280,popover.scrollHeight||160);
    const flip=below<Math.min(desired,140)&&above>below;
    const free=Math.max(52,flip?above:below);
    const maxHeight=Math.max(52,Math.min(280,free-5));
    popover.style.width=`${width}px`;
    popover.style.maxHeight=`${maxHeight}px`;
    popover.style.left=`${left}px`;
    const height=Math.min(maxHeight,popover.scrollHeight);
    popover.style.top=`${Math.max(6,flip?r.top-height-5:r.bottom+5)}px`;
  }
  function openMenu(trigger){
    const option=trigger.closest('.product_item_option');
    const original=option?.querySelector('.product_item_option_select');
    const scroller=trigger.closest('[data-af-recommended-scroll]');
    if(!original||!scroller)return;
    const originals=[...original.querySelectorAll('.product_item_option_select_item')];
    if(originals.length<2)return;
    if(current?.trigger===trigger){closeMenu();return;}
    closeMenu();
    const menu=ensurePopover();
    const display=trigger.querySelector('.product_item_option_value_ty');
    const currentTitle=display?.textContent.trim()||'';
    originals.forEach((item,index)=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='af-rec-variant-option';
      button.setAttribute('role','option');
      button.dataset.originalIndex=String(index);
      button.textContent=item.textContent.trim();
      button.setAttribute('aria-selected',String(button.textContent===currentTitle));
      menu.appendChild(button);
    });
    current={trigger,scroller,originals,display};
    trigger.setAttribute('role','button');
    trigger.setAttribute('aria-haspopup','listbox');
    trigger.setAttribute('aria-controls',menu.id);
    trigger.setAttribute('aria-expanded','true');
    menu.setAttribute('data-open','true');
    positionMenu();
  }
  function choose(index){
    if(!current)return;
    const {originals,trigger,display}=current;
    const item=originals[index];
    if(!item){closeMenu();return;}
    const title=item.textContent.trim();
    const id=item.dataset.id;
    const card=trigger.closest('[data-af-addon-card]');
    // Forward a click to the REAL option, preserving the theme's existing SKU,
    // quantity, price and Recommended Total event handling.
    item.click();
    if(display)display.textContent=title;
    if(id&&card){
      card.dataset.afVariantId=id;
      const check=card.querySelector('.Recommended_product_item_input_div');
      const qty=card.querySelector('input.input_quantity_int');
      if(check)check.dataset.id=id;
      if(qty)qty.dataset.id=id;
    }
    closeMenu({focus:true});
    window.AFRecommendedTotal?.refresh?.();
  }

  // Capture before the original theme's in-flow-dropdown handler can open it.
  document.addEventListener('click',event=>{
    const trigger=event.target.closest?.('[data-af-recommended] .product_item_option_value');
    if(!trigger)return;
    if(!trigger.closest('.product_item_option')?.querySelector('.product_item_option_select'))return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openMenu(trigger);
  },true);
  document.addEventListener('keydown',event=>{
    if((event.key==='Enter'||event.key===' ')&&event.target.matches?.('[data-af-recommended] .product_item_option_value')){
      event.preventDefault();openMenu(event.target);return;
    }
    if(event.key==='Escape'&&current){event.preventDefault();closeMenu({focus:true});}
  },true);
  document.addEventListener('pointerdown',event=>{
    if(current&&!popover?.contains(event.target)&&!current.trigger.contains(event.target))closeMenu();
  },true);
  document.addEventListener('scroll',event=>{
    if(current&&event.target!==popover)closeMenu();
  },true);
  window.addEventListener('resize',()=>closeMenu(),{passive:true});
  document.addEventListener('click',event=>{
    const choice=event.target.closest?.('.af-rec-variant-popover .af-rec-variant-option');
    if(choice)choose(Number(choice.dataset.originalIndex));
  });
  document.addEventListener('keydown',event=>{
    if(!current||!popover?.contains(event.target))return;
    if(event.key==='ArrowDown'||event.key==='ArrowUp'){
      event.preventDefault();const options=[...popover.querySelectorAll('button')];
      const i=options.indexOf(document.activeElement);
      options[(i+(event.key==='ArrowDown'?1:-1)+options.length)%options.length]?.focus();
    }
  });

  function setup(scroller){
    if(active.has(scroller))return;
    active.add(scroller);
    scroller.querySelectorAll('.product_item_option_value').forEach(trigger=>{
      if(trigger.closest('.product_item_option')?.querySelectorAll('.product_item_option_select_item').length>1){
        trigger.tabIndex=0;trigger.setAttribute('role','button');
        trigger.setAttribute('aria-expanded','false');trigger.setAttribute('aria-haspopup','listbox');
      }
    });
    const cards=[...scroller.querySelectorAll('[data-af-addon-card]')];
    if(cards.length<3)return; // 1 or 2 cards: natural height, menus still float.
    const third=cards[2];
    const price=third.querySelector('.Recommended_product_item_text_centent_yprict');
    scroller.classList.add('af-rec-vertical-scroll');
    scroller.tabIndex=0;
    scroller.setAttribute('role','region');
    scroller.setAttribute('aria-label','Más productos, desplázate para ver todas las opciones');
    let pending=false;
    const measure=()=>{
      pending=false;
      if(!scroller.isConnected)return;
      const scroll=rect(scroller),thirdRect=rect(third),priceRect=rect(price);
      if(!scroll||!thirdRect||thirdRect.height<1)return;
      const cutoff=(priceRect?.height?priceRect.bottom:thirdRect.top+thirdRect.height*.55)-scroll.top+scroller.scrollTop+14;
      const height=Math.round(Math.max(180,Math.min(760,cutoff)));
      const old=parseInt(scroller.style.getPropertyValue('--af-rec-height'),10)||0;
      if(Math.abs(height-old)>2)scroller.style.setProperty('--af-rec-height',`${height}px`);
    };
    const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(measure)}};
    schedule();
    if('ResizeObserver'in window){
      const observer=new ResizeObserver(schedule);
      cards.slice(0,3).forEach(card=>observer.observe(card));
      scroller._afRecommendResize=observer;
    }
    window.addEventListener('resize',schedule,{passive:true});
    document.fonts?.ready?.then(schedule);
    scroller._afRecommendCleanup=()=>{
      scroller._afRecommendResize?.disconnect();
      window.removeEventListener('resize',schedule);
    };
  }
  function init(root){
    if(root.matches?.('[data-af-recommended-scroll]'))setup(root);
    root.querySelectorAll?.('[data-af-recommended-scroll]').forEach(setup);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    closeMenu();
    event.target.querySelectorAll?.('[data-af-recommended-scroll]').forEach(el=>el._afRecommendCleanup?.());
  });
})();
